import "./Join.css";

const Join = () => {
  return (
    <div className="Join" id="join-us">
      <div className="left-j">
        <hr />
        <div>
          <span className="stroke-text">Spreman da</span>
          <span>unaprediŠ</span>
        </div>
        <div>
          <span>svoje veŠtine</span>
          <span className="stroke-text">sa nama?</span>
        </div>
      </div>
    </div>
  );
};

export default Join;
